import React from "react"
import Button, { ButtonProps } from "@mui/material/Button"

const getCsrfToken = () => {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute("content") : ""
}

interface PostButtonProps extends Omit<ButtonProps, "type" | "action"> {
  action: string
  "data-testid"?: string
}

const PostButton = ({ action, children, "data-testid": testId, ...buttonProps }: PostButtonProps) => {
  return (
    <form action={action} method="post" data-testid={testId ? `${testId}-form` : undefined}>
      <input type="hidden" name="authenticity_token" value={getCsrfToken() || ""} />
      <Button type="submit" data-testid={testId} {...buttonProps}>
        {children}
      </Button>
    </form>
  )
}

export default PostButton
